module.exports = __webpack_public_path__ + "img/014-idea.edc6d6c7.svg";